import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Header from './components/Header';
import Footer from './components/Footer';
import HomePage from './components/HomePage';
import ServicesPage from './components/ServicesPage';
import AboutPage from './components/AboutPage';
import ContactPage from './components/ContactPage';
import UseCasesPage from './components/UseCasesPage';
import UseCaseCloudTransformation from './components/UseCaseCloudTransformation';
import UseCaseAIDocumentation from './components/UseCaseAIDocumentation';
import UseCaseAIFoodBeverage from './components/UseCaseAIFoodBeverage';
import UseCaseAgriFood from './components/UseCaseAgriFood';
import BookPage from './components/BookPage';
import SustainableAIFrameworkPage from './components/SustainableAIFrameworkPage';
import TechniquesToolsPage from './components/TechniquesToolsPage';

function App() {
  return (
    <Router>
      <div className="App">
        <Header />
        <main>
          <Routes>
            <Route path="/" element={<HomePage />} />
            <Route path="/services" element={<ServicesPage />} />
            <Route path="/about" element={<AboutPage />} />
            <Route path="/book" element={<BookPage />} />
            <Route path="/resources/sustainable-ai-framework" element={<SustainableAIFrameworkPage />} />
            <Route path="/resources/techniques-tools" element={<TechniquesToolsPage />} />
            <Route path="/use-cases" element={<UseCasesPage />} />
            <Route path="/use-cases/cloud-transformation" element={<UseCaseCloudTransformation />} />
            <Route path="/use-cases/ai-pharma" element={<UseCaseAIDocumentation />} />
            <Route path="/use-cases/ai-food-beverage" element={<UseCaseAIFoodBeverage />} />
            <Route path="/use-cases/agri-food" element={<UseCaseAgriFood />} />
            
            <Route path="/contact" element={<ContactPage />} />
          </Routes>
        </main>
        <Footer />
      </div>
    </Router>
  );
}

export default App;
